import { TaskEstimatedDurations } from '@nexelem/graphne-api';

export const getPossibleQueues = (node?: { estimatedDurations?: TaskEstimatedDurations }) =>
  node?.estimatedDurations?.durations ? Object.keys(node.estimatedDurations.durations).map(Number) : undefined;
